<div class="container-fluid widget-wrapper" #widgetHeader>
  <div class="row widget-header" [ngClass]="{ sticky: isTop }">
    <div class="col-lg-12">
      <h2>
        <span>Authorized Seller (app-ads.txt)</span><span class="app-title">&nbsp;{{ appName | appPrefix }}</span>
        <a class="btn btn-link help-icon" data-placement="top" data-toggle="tooltip" enTooltip title="The contribution of various sell side platforms to programmatic ad impressions sold on the app.">
          <img src="/assets/images/icon-indicator-info.svg" alt="Info Icon"/>
        </a>
        <img class="beta-tag" src="/assets/images/beta-tag.png" alt="Beta Tag"/>
        <ng-container *ngTemplateOutlet="swiperControls"></ng-container>
      </h2>
    </div>
  </div>
  <div class="row widget-body pt-0">
    <div class="col-lg-12 px-0">
      <app-sov [os]="os" [data]="data" [isFollowing]="isFollowing" [isFreemium]="isFreemium"
               (followClick)="followButtonClick.emit($event)">
      </app-sov>
    </div>
  </div>
</div>
